import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export { BatteryIndicatorHorizontal };

function BatteryIndicatorHorizontal({ percentage, height = '60px', mb='4' }) {
    // Limite le pourcentage entre 0 et 100
    const clampedPercentage = (percentage !== 'N/A' && percentage !== 0) ? Math.min(Math.max(parseInt(percentage), 0), 100) : 'N/A';
    const value = `${clampedPercentage }${(percentage !== 'N/A' && percentage !== 0) ? '%' : ''}`;
    const [ color, setColor ] = useState('green')
    const { pathname } = useLocation()

    const textColor = pathname.includes('flotte') ? '' : 'text-global-white';

    useEffect(() => {
        if(percentage < 13) {
            setColor('red')
        } else if (13 <= percentage && percentage <30){
            setColor('orange')
        } else {
            setColor('green')
        }
    }, [percentage])

    return (
        <div className={`battery-indicator-container h-[${height}] mb-${mb}`}>
            <div className='battery-indicator-border'>
                <div className={`battery-percentage bg-primary-${color}`} style={{width: `${clampedPercentage}%`}}/>
                <div className={`battery-percentage-text ${textColor}`}>
                    {value}
                </div>         
            </div>   
            <div className='battery-endsquare'/>           
        </div>
    );
};
